import fp from 'lodash/fp';
import React from 'react';
import queryString from 'query-string';
import { format } from 'date-fns';
import { Breadcrumb, BreadcrumbItem } from "react-bootstrap";
import { connect } from 'react-redux';
import { LinkContainer } from "react-router-bootstrap";
import { compose, lifecycle, withProps } from 'recompose';
import { bindActionCreators } from 'redux';
import { dateFormats, routes } from "../../../../constants";
import { getDefaultProgressLabel, startOfNextCpdPeriod, startOfThisCpdPeriod } from '../../../../services';
import { cpdPointActions, cpdPointsSelector } from '../../../../state/modules/cpd-points';
import { currentUserSelector, userActions, userAfslSelector } from '../../../../state/modules/user';
import ProgressReport from '../../shared/progress-report';

const reportBreadCrumb =
  <Breadcrumb>
    <LinkContainer to={routes.app.professionalProfile.root}>
      <BreadcrumbItem>
        Professional profile
            </BreadcrumbItem>
    </LinkContainer>
    <LinkContainer to={routes.app.professionalProfile.cpdActivity}>
      <BreadcrumbItem>
        CPD Activity
            </BreadcrumbItem>
    </LinkContainer>
    <BreadcrumbItem active>
      Progress Report
        </BreadcrumbItem>
  </Breadcrumb>

const mapStateToProps = (state) => ({
  afsLicence: userAfslSelector(state),
  cpdActivity: cpdPointsSelector(state),
  user: currentUserSelector(state),
  cpdCategoryProgress: state.user.cpdCategoryProgress,
  industryCpdCategorys: state.industry.cpdCategorys,
  defaultProgressLabel: getDefaultProgressLabel(state.user.profile),
  industryRoleMonths: fp.flow(
    fp.get('user.currentUserIndustryRoles'),
    fp.first,
    fp.get('months')
  )(state)
});

const mapDispatchToProps = (dispatch) => ({
  getCpdPoints: bindActionCreators(cpdPointActions.cpdPoints.get, dispatch),
  getCpdCategorys: bindActionCreators(userActions.user.getCpdCategorys, dispatch)
});

export default compose(
  withProps(() => {
    const parsed = queryString.parse(window.location.search);
    return ({
      showCpdPeriodSelect: true,
      yearsFromNow: Math.min(parseInt(parsed.yearsFromNow, 10) || 0, 0),
    })
  }),
  connect(mapStateToProps, mapDispatchToProps),
  withProps(
    ({ cpdCategoryProgress }) => ({
      cpdDaysRemaining: fp.get('primaryStat.cpdRemainingDays')(cpdCategoryProgress)
    })
  ),
  withProps(({ cpdDaysRemaining, industryRoleMonths, industryCpdCategorys }) => ({
    filter: {
      fromDate: cpdDaysRemaining !== undefined && industryRoleMonths ? format(startOfThisCpdPeriod(cpdDaysRemaining, industryRoleMonths), dateFormats.FilteringDate) : '',
      toDate: cpdDaysRemaining !== undefined ? format(startOfNextCpdPeriod(cpdDaysRemaining), dateFormats.FilteringDate) : '',
      cpdCategorys: fp.map('id')(industryCpdCategorys).join(',')
    }
  })),
  lifecycle({
    componentDidMount() {
      const {
        getCpdCategorys,
        yearsFromNow,
        filter,
        getCpdPoints,
      } = this.props;

      getCpdCategorys(undefined, { yearsFromNow });
      getCpdPoints(filter);
    },
    componentDidUpdate(prevProps) {
      const {
        filter,
        getCpdPoints,
      } = this.props;
      
      // When filter is updated, query the cpd points activity again.
      if (prevProps.filter.fromDate !== filter.fromDate 
        || prevProps.filter.toDate !== filter.toDate
        || prevProps.filter.cpdCategorys !== filter.cpdCategorys
      ) {
        getCpdPoints(filter);
      }
    }
  }),
  withProps(() => ({
    reportBreadCrumb
  }))
)(ProgressReport)


// WEBPACK FOOTER //
// ./src/containers/pages/app/professional-profile/individual-report.js